import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { deleteVerificationRuleMutation } from "mutations/verificationRuleMutations";
import { showIndex } from "utils/navigation";
import { notifications } from "@zendesk/knowledge-components/lib/Notifications/Connected";
import MutationWithOverlay from "components/MutationWithOverlay";
import t from "@zendesk/client-i18n-tools";

export default class DeleteVerificationRuleMutation extends PureComponent {
  static propTypes = {
    children: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
  };

  onDeleted = ({ deleteVerificationRule: { success } }) => {
    if (success) {
      showIndex({ skipDirtyCheck: true });
      notifications.showSuccess({
        message: t(
          "knowledge-verification.notification.verificationRuleDelete.message"
        ),
      });
    } else {
      notifications.showError({
        message: t(
          "knowledge-verification.notification.verificationRuleDelete.failed"
        ),
      });
    }
  };

  render() {
    const { children, id } = this.props;

    return (
      <MutationWithOverlay
        mutation={deleteVerificationRuleMutation}
        refetchQueries={["verificationRules"]}
        variables={{ id }}
        awaitRefetchQueries
        onCompleted={this.onDeleted}
      >
        {children}
      </MutationWithOverlay>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DeleteVerificationRuleMutation/index.js